<dx-popup
  (onHiding)="addGateway = false"
  *ngIf="addGateway"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="false"
  [fullScreen]="appService.isSmallScreen()"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY.TEXT.ADD_GATEWAY' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="createNewGateway(); focusInvalidTab(newGatewayForm)" [height]="40"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="addGateway = false; resetSelectedRowPartitionNewGatewayForm.emit();" [height]="40"
               [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <dx-form #newGatewayForm
           [formData]="newGateway"
           [labelLocation]="'top'"
           [labelMode]="'floating'"
  >
    <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
      <span>{{ tab.title }}</span>
      <div *ngIf="!checkTabValidity(tab, newGatewayForm)" class="invalidBadge">!</div>
    </div>
    <dxi-item itemType="tabbed">
      <dxo-tab-panel-options [deferRendering]="false"
                             [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.GATEWAY.TABS.INFORMATION' | translate}}">
        <dxi-item [editorOptions]="gatewayNewTextOptions" dataField="name">
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxo-label text="{{'REGISTRY.GATEWAY.NAME' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.GATEWAY.VALIDATION.NAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="{
                  dataSource: gatewayTypes,
                  displayExpr: 'modelName',
                  valueExpr: 'id'
                }" dataField="type.id"
                  editorType="dxSelectBox"
        >
          <dxo-label text="{{'REGISTRY.GATEWAY.TYPE' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.GATEWAY.VALIDATION.TYPE' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="{
              dataSource: sendingCronFrequencyValues,
              displayExpr: getAcquisitionCronLabel,
          }" dataField="sendingCron"
                  editorType="dxSelectBox"
        >
          <dxo-label text="{{'REGISTRY.GATEWAY.SENDING_FREQUENCY' | translate}}"></dxo-label>
          <dxi-validation-rule message="{{'REGISTRY.GATEWAY.VALIDATION.SENDING_FREQUENCY' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>
      </dxi-tab>
    </dxi-item>

  </dx-form>

</dx-popup>
